<div class="settings-page" [class.sidebar-minimized]="isSidebarMinimized">
  <!-- Precision Sidebar -->
  <aside class="settings-sidebar">
    <button mat-icon-button (click)="isSidebarMinimized = !isSidebarMinimized" class="toggle-btn"
      [matTooltip]="isSidebarMinimized ? 'Expand sidebar' : 'Collapse sidebar'" matTooltipPosition="right">
      <mat-icon>{{isSidebarMinimized ? 'chevron_right' : 'chevron_left'}}</mat-icon>
    </button>

    <nav class="sidebar-nav">
      <div class="nav-group">
        <div class="nav-item" [class.active]="selectedTabIndex === 0" (click)="onTabChange(0)"
          [matTooltip]="isSidebarMinimized ? 'Branding' : ''" matTooltipPosition="right">
          <mat-icon>palette</mat-icon>
          <span class="nav-text">Branding</span>
        </div>
        <div class="nav-item" [class.active]="selectedTabIndex === 1" (click)="onTabChange(1)"
          [matTooltip]="isSidebarMinimized ? 'Team' : ''" matTooltipPosition="right">
          <mat-icon>group</mat-icon>
          <span class="nav-text">Team Members</span>
          <span class="nav-badge" *ngIf="admins?.length && !isSidebarMinimized">{{admins.length}}</span>
        </div>
        <div class="nav-item" [class.active]="selectedTabIndex === 2" (click)="onTabChange(2)"
          [matTooltip]="isSidebarMinimized ? 'Billing' : ''" matTooltipPosition="right"
          *ngIf="currentUser?.role === 'ENTERPRISE_ADMIN'">
          <mat-icon>payments</mat-icon>
          <span class="nav-text">Billing</span>
        </div>
        <div class="nav-item" [class.active]="selectedTabIndex === 3" (click)="onTabChange(3)"
          [matTooltip]="isSidebarMinimized ? 'Reminders' : ''" matTooltipPosition="right">
          <mat-icon>notifications_active</mat-icon>
          <span class="nav-text">Reminders</span>
          <span class="nav-badge new" *ngIf="!isSidebarMinimized">New</span>
        </div>
      </div>
    </nav>
  </aside>

  <!-- Modern Engine Main -->
  <main class="settings-main">
    <header class="header-wrapper">
      <div class="header-content-inner">

        <div class="header-main">
          <div class="icon-orb">
            <mat-icon *ngIf="selectedTabIndex === 0">palette</mat-icon>
            <mat-icon *ngIf="selectedTabIndex === 1">group</mat-icon>
            <mat-icon *ngIf="selectedTabIndex === 2">payments</mat-icon>
            <mat-icon *ngIf="selectedTabIndex === 3">notifications_active</mat-icon>
          </div>
          <div class="title-stack">
            <h1>{{ (['Branding & Identity', 'Team Management', 'Billing & Subscription', 'Reminders'])[selectedTabIndex]
              }}</h1>
            <p>
              {{ (['Customize your brand look and communication templates',
              'Manage organization access and invited members',
              'Review your subscription, plan and history',
              'Configure automated candidate follow-up rules'])[selectedTabIndex] }}
            </p>
          </div>
        </div>
      </div>
    </header>

    <div class="content-area-fluid">
      <!-- Branding Component -->
      <app-branding *ngIf="selectedTabIndex === 0" [isSubComponent]="true"></app-branding>

      <!-- Team Content (Placeholder for Redesign) -->
      <app-team *ngIf="selectedTabIndex === 1"></app-team>

      <!-- Billing Content -->
      <app-billing *ngIf="selectedTabIndex === 2 && currentUser?.role === 'ENTERPRISE_ADMIN'"></app-billing>

      <!-- Reminders Content -->
      <app-reminders *ngIf="selectedTabIndex === 3"></app-reminders>
    </div>
  </main>
</div>